import { gsap } from "gsap/dist/gsap";

import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { TextPlugin } from "gsap/dist/TextPlugin";

/* The following plugin is a Club GSAP perk */
import { SplitText } from "gsap/dist/SplitText";

gsap.registerPlugin(ScrollTrigger,TextPlugin,SplitText);

const herotitle = document.querySelectorAll(".hero__title p");

function setupSplits() {
  $(document).ready(function(){
    $(".split-line").wrap('<div class="split-parent"></div>');
  });

  herotitle.forEach(quote => {

    // SplitText für Zeilen und Wörter anwenden
    quote.split = new SplitText(quote, {
      type: "lines,words",  // Split für Zeilen, Wörter und Zeichen
      linesClass: "split-line",    // Klasse für Zeilen
      wordsClass: "split-word"     // Klasse für Wörter
    });

    // Anfangs verstecken
    gsap.set(quote, { visibility: "visible", opacity: 1 });

    // Animation für die Zeilen
    quote.anim = gsap.from(quote.split.lines, {
      scrollTrigger: {
        trigger: quote,
        toggleActions: "restart pause resume reverse",
        start: "50% 60%",
      },
      duration: .5,
      ease: "power4.out",
      yPercent: 100,
      stagger: .1,  // Abstand zwischen den Zeilen
      opacity: 1, // Sichtbar machen
    });
  });
}

export default setupSplits
